import { findBy } from "neetocist";
import { prop, isEmpty, uniqBy, mergeLeft } from "ramda";

export const parseVariables = (variableArr = []) => {
  const uncategorized = [];
  const groupedVariables = [];
  const categorySet = new Set();

  variableArr.forEach(variable => {
    const { category, label, variables } = variable;
    if (category && variables) {
      const parsedVariables = variables.map(
        mergeLeft({ category, categoryLabel: label })
      );

      if (!categorySet.has(category)) {
        categorySet.add(category);
        groupedVariables.push({ label, variables: parsedVariables });
      } else {
        const existingGroup = findBy({ label }, groupedVariables);

        existingGroup.variables = uniqBy(
          prop("key"),
          existingGroup.variables.concat(parsedVariables)
        );
      }
    } else {
      uncategorized.push(variable);
    }
  });

  if (!isEmpty(uncategorized)) {
    groupedVariables.push({
      label: !isEmpty(groupedVariables) ? "Others" : null,
      variables: uncategorized,
    });
  }

  return groupedVariables;
};
